import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.css";
import swal from "sweetalert";
import { verifyVC, verifyVP } from "../Helpers/verify-cred.js";
import Header from "../components/Header.js";
import IdentitySchemaInput from "../components/Schemas/Identity.js";
import VCstatus from "../components/StatusTab/VCstatus.js";
import QRCard from "../components/QrcodeCard/QRCard.js";
import VPstatus from "../components/StatusTab/VPstatus.js";
import Footer from "../components/Footer.js";
import LoadCanvasPages from "../components/CanvasPages/LoadCanvasPages.js";
import CertificateConfig from "../constants/certificateConfig.json";
import IdentityConfig from "../constants/identityConfig.json";
import identityThumbail from "../assets/identity.png";
import certificateThumbail from "../assets/certificate.png";
import jobDetailsThumbail from "../assets/jobdetails.svg";
import CertificateSchemaInput from "../components/Schemas/Certificate.js";
import JobDetailsSchemaInput from "../components/Schemas/JobDetails.js";
import { Modalprogress } from "../components/Modal/Modalprogress.jsx";
import Loaderspinner from "../components/Loader/Loaderspinner.js";
import QRCardVerify from "../components/QrcodeCard/QRCardVerify.js";
import { Modalsuccess } from "../components/Modal/Modalsuccess.js";
import Loaderflip from "../components/Loader/Loaderflip.js";
import identitySchema from "../constants/schema/identify.json";
import certificateSchema from "../constants/schema/certificate.json";
import jobDetailsSchema from "../constants/schema/jobDetails.json";
import { generateVC } from "../Helpers/createVC.js";
import fileThumb from "../assets/file.svg";
import Fileinput from "../components/Fileinput/Fileinput.jsx";
import TabsHeading from "../components/Tabs/Tabsheading.jsx";
import UpdatedocInput from "../components/UpdatedocInput/UpdatedocInput.jsx";
import RevokeInput from "../components/RevokeInput/RevokeInput.jsx";
import { AlreadyExistModal } from "../components/Modal/AlreadyExist.js";

function Verify() {
  const {
    REACT_APP_API_URL,
    REACT_APP_ACCESS_TOKEN,
    REACT_APP_PROFILE_ADDRESS,
  } = process.env;
  const ModifiedConfig = useRef(CertificateConfig);
  const [textJson, setTextJson] = useState();
  const [textJsonCreate, setTextJsonCreate] = useState("");
  const [statusVc, setStatusVC] = useState();
  const [statusVp, setStatusVP] = useState();
  const [isProgress, setProgress] = useState(false);
  const [schemaList, setSchemaList] = useState();
  const [activeBt, setActiveBt] = useState();
  const [selectedSchema, setSelectedSchema] = useState();
  const [schemaProps, setSchemaProps] = useState();
  const [selectedSchemaData, setSelectedSchemaData] = useState();
  const [requiredFields, setRequiredFields] = useState();
  const [selectedRegistryData, setRegistryData] = useState();
  // const [fieldsArray, setFieldsArray] = useState();
  const [actTab, setActTab] = useState("create");
  const [stateJSON, setStateJSON] = useState("notSubmitted");
  const [loading, setLoading] = useState(false);
  const [issueToMe, setIssuetoMe] = useState(false);
  const [issueVerified, setIssueVerfied] = useState(false);
  const [verified, setVerified] = useState();
  const [reverify, setReverify] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loadingTxt, setloadingTxt] = useState(false);
  const [doneIssue, setDoneIssue] = useState(false);
  const [footerClose, setFooterClose] = useState(false);
  const [alreadyExist, setAlreadyExist] = useState(false);
  // const [footerClose, setFooterClose] = useState(
  //   localStorage.getItem("footerPlaygorund") === "true"
  // );
  const [selectedDocument, setSelectedDocument] = useState();
  const [reRenderCanvas, setReRenderCanvas] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [canvasLoading, setCanvasLoading] = useState(false);
  const [lastCretedJson, setLastCreatedJson] = useState();
  const [blinker, showBlinker] = useState();
  const [fileSchemaSelected, setFileSchemaSelected] = useState(false);
  const listtoeknization = ["create", "verify", "update", "revoke"];
  const TextAreaRef = useRef(null);
  const inputJson = useRef(null);
  const pageCanvas = useRef([]);
  const thumbnails = useRef([]);
  const jsonContainerRef = useRef(null);

  useEffect(() => {
    //INFO: planned feature addon
    // initCord()
    const configJson = [CertificateConfig, IdentityConfig];
    configJson.forEach((configObject, inputConfigIndex) => {
      const configArray = Object.values(configObject);
      const initialTextObject = { certificate: null, identity: null };

      configArray.forEach((config) => {
        config.objects?.forEach((obj) => {
          if (obj.type === "textbox") {
            if (inputConfigIndex === 0) {
              initialTextObject.certificate = {};
            } else {
              initialTextObject.identity = {};
            }
          }
        });
      });
    });
  }, []);

  useEffect(() => {
    if (doneIssue) {
      setSuccessModal(true);
      setTimeout(() => {
        setSuccessModal(false);
      }, 3000);
    }
  }, [doneIssue]);

  useEffect(() => {
    if (alreadyExist) {
      setErrorModal(true);
      setTimeout(() => {
        setErrorModal(false);
      }, 3000);
    }
  }, [alreadyExist]);
  //Checking if JSONstring is pasted
  function isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      swal({
        title: "Invalid JSON format",
        text: "",
        icon: "warning",
      });
      return false;
    }
    return true;
  }

  //Cheking if JSON vp or vc
  function isJsonVCVP(str) {
    const jsonData = JSON.parse(str);
    if (
      jsonData["type"] &&
      (jsonData["type"].includes("VerifiablePresentation") ||
        jsonData["type"].includes("VerifiableCredential"))
    ) {
      return true;
    } else {
      swal({
        title:
          "Provide  Verifiable Credential or Verifiable Presentation format",
        text: "",
        icon: "warning",
      });
      return false;
    }
  }

  //Getting schemas list
  const getSchema = async () => {
    setSchemaList([
      {
        ...certificateSchema,
        registry: {
          ...certificateSchema.schema,
          details: certificateSchema.schema,
        },
      },
      {
        ...identitySchema,
        registry: { ...identitySchema.schema, details: identitySchema.schema },
      },
      {
        ...jobDetailsSchema,
        registry: {
          ...jobDetailsSchema.schema,
          details: jobDetailsSchema.schema,
        },
      },
    ]);
  };
  // Add this useEffect after your getSchema useEffect

  useEffect(() => {
    // Check if schemaList is available
    if (schemaList && schemaList.length > 0) {
      // Get Certificate Schema ID and title
      const certificateSchema = schemaList.find(
        (schema) =>
          schema.registry.details.description === "Certificate Schema" ||
          schema.registry.details.description
            .toLowerCase()
            .includes("certificate")
      );

      if (certificateSchema) {
        // Automatically select the Certificate Schema
        handleChangeSchema(
          certificateSchema.schema.$id,
          certificateSchema.registry.details.description
        );
      }
    }
  }, [schemaList]); // This will run whenever schemaList is loaded

  //Getting registery and schema fields
  const getSchemaRegistryDetails = (selectedOption) => {
    const schemaSelected = schemaList.filter(
      (data) => data.schema.$id === selectedOption
    );

    setRequiredFields(schemaSelected[0].schema.required);
    const fields = Object.entries(schemaSelected[0].registry.properties).map(
      ([key, value]) => {
        return key;
      }
    );
    const propsFields = fields.reduce((data, val) => {
      data[val] = "";
      return data;
    }, {});
    setSchemaProps(propsFields);
    schemaSelected[0].schema.title.toLowerCase().includes("identity")
      ? (ModifiedConfig.current = IdentityConfig)
      : schemaSelected[0].schema.title.toLowerCase().includes("job")
        ? (ModifiedConfig.current = CertificateConfig) // Using CertificateConfig for JobDetails for now
        : (ModifiedConfig.current = CertificateConfig);
    setReRenderCanvas(true);
  };

  //Handling change schema selection
  const handleChangeSchema = (option, title) => {
    clearCreate();
    if (option === 80) {
      setFileSchemaSelected(true);
    } else {
      setFileSchemaSelected(false);
      // getDidDetails();
      const selectedOption = option;
      setSelectedDocument(title);
      setSelectedSchema(selectedOption);
      getSchemaRegistryDetails(selectedOption);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 1000);
    }
  };

  //When loaded the json on create
  useEffect(() => {
    if (stateJSON === "loaded") {
      setReRenderCanvas(true);
      setTimeout(window.scrollTo(0, document.body.scrollHeight), 3000);
    }
  }, [stateJSON]);

  //setting Footer false local storage
  useEffect(() => {
    if (footerClose) {
      localStorage.setItem("footerPlaygorund", "true");
    } else {
      if (localStorage.getItem("footerPlaygorund") === "true") {
        setFooterClose(true);
      }
    }
  }, [footerClose]);

  // Visiblity change
  const focusTabChange = () => {};

  const blurTabChange = () => {
    // console.log("here blur", Timer);
    //        Timer = setTimeout(() => {
    //          setInactiveQr(true);
    //        }, 10000);
  };

  const createVc = async (qr) => {
    let schemaData;
    if (qr && stateJSON === "loaded") {
      setIssuetoMe(true);
    } else {
      setLoading(true);
      // console.log("here",selectedDocument);
      if (selectedDocument === "Certificate Schema") {
        schemaData = certificateSchema;
      } else if (selectedDocument === "Job Details Schema") {
        schemaData = jobDetailsSchema;
      } else {
        schemaData = identitySchema;
      }

      try {
        const vcOutput = await generateVC(schemaData.schema, schemaProps);
        prettyPrint(JSON.stringify(vcOutput), "create");
        setLoading(false);
        setLastCreatedJson(schemaProps);
        setStateJSON("loaded");
        if (qr) {
          setIssuetoMe(true);
        }
      } catch (e) {
        setLoading(false);
        const errorMessage = e.message
          ? e.message
          : "Please try again after sometime";
        swal({
          title: "Unable to issue ",
          text: errorMessage,
          icon: "error",
        });
      }
    }
  };

  useEffect(() => {
    getSchema();
    const dragMain = document.querySelector(".f-screen");
    const dragArea = document.querySelector(".drag-area");
    const verification = document.getElementById("verification");
    const verifyArea = document.querySelector(".verify-area");
    const fileUpload = document.querySelector(".fileUpload");
    let file;

    //file is pasted
    dragArea.addEventListener(
      "paste",
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        let paste = (event.clipboardData || window.clipboardData).getData(
          "text"
        );
        if (isJsonString(paste)) {
          if (isJsonVCVP(paste)) {
            prettyPrint(paste, "new");
          }
        }
      },
      false
    );

    dragArea.addEventListener(
      "input",
      (event) => {
        disableKeyPress(event);
      },
      false
    );

    dragArea.addEventListener("keydown", function (event) {
      // Check for Backspace or Delete key
      if (event.key === "Backspace" || event.key === "Delete") {
        if (TextAreaRef.current.innerHTML.length < 3) {
          event.preventDefault();
        }
      }
    });

    dragArea.addEventListener("keyup", (event) => {
      if (
        TextAreaRef &&
        TextAreaRef.current &&
        event.keyCode !== 91 &&
        event.keyCode !== 86 &&
        textJson !== TextAreaRef.current.innerHTML
      ) {
        setReverify(true);
      }
    });

    dragArea.addEventListener("dragover", (event) => {
      event.preventDefault();
    });
    verifyArea.addEventListener("dragover", (event) => {
      event.preventDefault();
    });

    // file leaves
    dragArea.addEventListener("dragleave", () => {});

    dragMain.addEventListener("dragstart", () => {});

    // file is dropped
    dragArea.addEventListener("drop", (event) => {
      event.preventDefault();
      file = event.dataTransfer.files[0];
      readFile();
    });
    verifyArea.addEventListener("drop", (event) => {
      event.preventDefault();
      event.stopPropagation();

      file = event.dataTransfer.files[0];
      readFile();
    });

    fileUpload.addEventListener("change", (event) => {
      event.preventDefault();
      event.stopPropagation();
      file = event.target.files[0];
      readFile();
    });

    function readFile() {
      let fileType = file.type;
      let validExtention = ["application/json", "text/plain"];
      if (validExtention.includes(fileType)) {
        let fileReader = new FileReader();

        fileReader.onload = () => {
          let fileData = fileReader.result;
          if (isJsonString(fileData)) {
            if (isJsonVCVP(fileData)) {
              prettyPrint(fileData, "readFile");
              dragArea.style.removeProperty("display");
              verification.hidden = false;
            }
          } else {
            return;
          }
        };
        fileReader.readAsText(file);
      } else {
        dragArea.classList.remove("active");
        swal({
          title: "The file is not a JSON",
          text: 'Make sure the file has a ".json" extention.',
          icon: "warning",
        });
      }
    }
    window.addEventListener("focus", focusTabChange);
    window.addEventListener("focus", blurTabChange);
    return () => {
      window.removeEventListener("focus", focusTabChange);
      window.removeEventListener("focus", blurTabChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prettyPrint = (data, formCheck) => {
try {

  const obj = typeof data === "string" ? JSON.parse(data) : data;
  const pretty = JSON.stringify(obj, null, 4);

  if (formCheck !== "create") {
    console.log("Entered Verify Part", formCheck,data);
    setProgress(true);

   const isVC =
  Array.isArray(obj?.type) &&
  obj.type.includes("VerifiableCredential");

const isVP =
  Array.isArray(obj?.type) &&
  obj.type.includes("VerifiablePresentation");


  if (isVC) {
  // ✅ VC verification
  setVerified("VC");
  setTimeout(() => {
    setStatusVP();
    verifyVC(obj)
      .then((data) => {
        setStatusVC(data);
        setProgress(false);
      })
      .catch((error) => {
        swal({
          title: typeof error === "string" ? error : "VC verification failed",
          icon: "warning",
        });
        setProgress(false);
      });
  }, 2000);

} else if (isVP) {
  // ✅ VP verification
  setVerified("VP");
  setTimeout(() => {
    setStatusVC();
    verifyVP(obj)
      .then((data) => {
        setStatusVP(data);
        setProgress(false);
      })
      .catch(() => {
        swal({
          title: "Unable to verify JSON",
          icon: "warning",
        });
        setProgress(false);
      });
  }, 2000);
}

  }

  if (formCheck === "create") {
    setTextJsonCreate(pretty);
  } else {
    setTextJson(pretty);
  }

} catch (err) {
  console.error("Invalid JSON", err);
}

    // document.getElementById('text-area').value = pretty;
  };

  const disableKeyPress = (e) => {
    var ctrl = e.ctrlKey ? e.ctrlKey : e.keyCode === 17 ? true : false;
    if (
      (e.keyCode === 86 && ctrl) ||
      (e.keyCode === 67 && ctrl) ||
      (e.keyCode === 88 && ctrl)
    ) {
      e.preventDefault();
      return true;
    } else {
      return false;
    }
  };

  const copyToClipBoard = (data) => {
    navigator.clipboard.writeText(data);
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 3000);
  };

  //VC scoll selection ---
  // Scroll into Signature view in drag area and select
  const scrollIntoCordProof2025 = () => {
    setActiveBt("CordProof");
    if (TextAreaRef.current) {
      const maintext = textJson;
      const JsonObj = JSON.parse(maintext);
      const siganature = JsonObj.proof[1];

      const stringSignatue = JSON.stringify(siganature);
      let regUpdate = "";
      for (let j = 0; j < stringSignatue.length; j++) {
        regUpdate = regUpdate + "\\s*" + stringSignatue[j];
      }
      const reg = new RegExp(regUpdate.replaceAll("[", "\\["));
      let newText = maintext.replace(
        reg,
        "<span class='selectedJson' id='JsonText'>" +
          JSON.stringify(siganature, null, 4) +
          "</span>"
      );
      newText = "<span id='removid'>" + newText + "</span>";
      TextAreaRef.current.innerHTML = newText;
      const ele = document.getElementById("JsonText");
      ele.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Scroll into BlockChainState view in drag area and select
  const scrollIntoSignature = () => {
    setActiveBt("Ed25519Signature2020");
    if (TextAreaRef.current) {
      const maintext = textJson;
      const JsonObj = JSON.parse(maintext);
      const CordCredential = JsonObj.proof[0];

      const stringSignatue = JSON.stringify(CordCredential);
      let regUpdate = "";
      for (let j = 0; j < stringSignatue.length; j++) {
        regUpdate = regUpdate + "\\s*" + stringSignatue[j];
      }
      const reg = new RegExp(regUpdate.replaceAll(/[[\](){}+]/g, "\\$&"));
      let newText = maintext.replace(
        reg,
        "<span class='selectedJson' id='JsonText'>" +
          JSON.stringify(CordCredential, null, 4) +
          "</span>"
      );
      newText = "<span id='removid'>" + newText + "</span>";
      TextAreaRef.current.innerHTML = newText;
      const ele = document.getElementById("JsonText");
      ele.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Scroll into Digest view in drag area and select
  const scrollIntoCordSDRProof = () => {
    setActiveBt("CordSDRProof");
    if (TextAreaRef.current) {
      const maintext = textJson;
      const JsonObj = JSON.parse(maintext);
      const digest = JsonObj.proof[2];
      const stringSignatue = JSON.stringify(digest);
      let regUpdate = "";
      for (let j = 0; j < stringSignatue.length; j++) {
        regUpdate = regUpdate + "\\s*" + stringSignatue[j];
      }
      const reg = new RegExp(regUpdate.replaceAll("[", "\\["));
      let newText = maintext.replace(
        reg,
        "<span class='selectedJson' id='JsonText'>" +
          JSON.stringify(digest, null, 4) +
          "</span>"
      );
      newText = "<span id='removid'>" + newText + "</span>";
      TextAreaRef.current.innerHTML = newText;
      const ele = document.getElementById("JsonText");
      ele.scrollIntoView({ behavior: "smooth" });
    }
  };
  //VC scoll selection End ---

  ////////// VP results selection
  // Scroll into Signature view in drag area and select
  const scrollIntoSignatureVP = () => {
    setActiveBt("Ed25519Signature2020");
    if (TextAreaRef.current) {
      const maintext = textJson;
      const JsonObj = JSON.parse(maintext);
      const siganature = JsonObj.VerifiableCredential[0].proof[0];

      const stringSignatue = JSON.stringify(siganature);
      let regUpdate = "";
      for (let j = 0; j < stringSignatue.length; j++) {
        regUpdate = regUpdate + "\\s*" + stringSignatue[j];
      }
      const reg = new RegExp(regUpdate.replaceAll(/[[\](){}+]/g, "\\$&"));
      let newText = maintext.replace(
        reg,
        "<span class='selectedJson' id='JsonText'>" +
          JSON.stringify(siganature, null, 4) +
          "</span>"
      );
      newText = "<span id='removid'>" + newText + "</span>";
      TextAreaRef.current.innerHTML = newText;
      const ele = document.getElementById("JsonText");
      ele.scrollIntoView({ behavior: "smooth" });
    }
  };
  // Scroll into StreamStateBp view in drag area and select
  const scrollIntoCordSDRProofVP = () => {
    setActiveBt("CordSDRProof");
    if (TextAreaRef.current) {
      const maintext = textJson;
      const JsonObj = JSON.parse(textJson);
      const CordCredential = JsonObj.VerifiableCredential[0].proof[1];

      const stringSignatue = JSON.stringify(CordCredential);
      let regUpdate = "";
      for (let j = 0; j < stringSignatue.length; j++) {
        regUpdate = regUpdate + "\\s*" + stringSignatue[j];
      }
      const reg = new RegExp(regUpdate.replaceAll("[", "\\["));
      let newText = maintext.replace(
        reg,
        "<span class='selectedJson' id='JsonText'>" +
          JSON.stringify(CordCredential, null, 4) +
          "</span>"
      );
      newText = "<span id='removid'>" + newText + "</span>";
      TextAreaRef.current.innerHTML = newText;
      const ele = document.getElementById("JsonText");
      ele.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Scroll into Digest view in drag area and select
  const scrollIntoCordProofVP = () => {
    setActiveBt("CordProof2025");
    if (TextAreaRef.current) {
      const maintext = textJson;
      const JsonObj = JSON.parse(maintext);
      const digest = JsonObj.VerifiableCredential[0].proof[2];
      const stringSignatue = JSON.stringify(digest);
      let regUpdate = "";
      for (let j = 0; j < stringSignatue.length; j++) {
        regUpdate = regUpdate + "\\s*" + stringSignatue[j];
      }
      const reg = new RegExp(regUpdate.replaceAll("[", "\\["));
      let newText = maintext.replace(
        reg,
        "<span class='selectedJson' id='JsonText'>" +
          JSON.stringify(digest, null, 4) +
          "</span>"
      );
      newText = "<span id='removid'>" + newText + "</span>";
      TextAreaRef.current.innerHTML = newText;
      const ele = document.getElementById("JsonText");
      ele.scrollIntoView({ behavior: "smooth" });
    }
  };

  ////////// VP results selection end
  const updateCanvasObject = (event, eventName) => {
    let name = event.target?.name ? event.target.name : eventName;
    let input = event.target?.value
      ? event.target.value
      : typeof event === "string"
        ? event
        : "";
    const updatedConfig = Object.values(ModifiedConfig.current).map(
      (config) => {
        if (typeof config !== "object") {
          return null;
        }
        config.objects.forEach((obj) => {
          const regex = `{{record.${name?.toLowerCase()}}}`;

          if (obj.textId?.includes(regex) || obj.text?.includes(regex)) {
            if (obj.text?.includes(regex)) {
              obj.text = obj.text.replace(regex, input);
            } else {
              obj.text = input;
            }
          } else {
            if (
              eventName?.toLowerCase().includes("photo") &&
              obj.cusdata === regex
            ) {
              obj.objects.forEach((o) => {
                if (o.type === "image") {
                  o.src = event;
                } else {
                  o.text = "";
                }
              });
            }
          }
          return obj;
        });
        return config;
      }
    );
    ModifiedConfig.current = updatedConfig;
  };
  //Removing the Json
  const removeFile = () => {
    if (activeBt !== undefined && activeBt !== "") {
      setActiveBt("");
      setStatusVC();
      setStatusVP();
      setloadingTxt(true);
      setTimeout(() => {
        setTextJson("");
        setloadingTxt(false);
      }, 1000);
    }
    setloadingTxt(true);
    setVerified();
    setStatusVC();
    setStatusVP();
    setTimeout(() => {
      setTextJson("");
      setloadingTxt(false);
    }, 1000);
    setReverify(false);
  };

  const handlePic = (event) => {
    const file = event.target.files[0];
    if (event.target.files[0] && event.target.files[0].size < 2000000) {
      if (file) {
        const reader = new FileReader();

        reader.onload = () => {
          const base64String = reader.result;
          updateCanvasObject(base64String, event.target.name);
          setSchemaProps({
            ...schemaProps,
            [event.target.name]: base64String,
          });
        };

        reader.readAsDataURL(file);
      } else {
        setSchemaProps({
          ...schemaProps,
          [event.target.name]: "",
        });
      }
    } else if (event.target.files[0] && event.target.files[0].size >= 2000000) {
      event.target.value = "";
      swal({
        title:
          "Image exceeds the maximum size limit. Maximum upload size is 2MB",
        text: "",
        icon: "warning",
      });
    }
  };

  const handleDataPicker = (key, value) => {
    const date = value["$d"].toString();
    setSchemaProps({
      ...schemaProps,
      [key]: date,
    });
    updateCanvasObject(date.slice(4, 16), key);
  };

  const handleChangeFields = (ev) => {
    if (ev.target.name === "mobile" && ev.target.value.length > 10) {
    } else {
      updateCanvasObject(ev);
      setSchemaProps({ ...schemaProps, [ev.target.name]: ev.target.value });
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      setCanvasLoading(true);
      setTimeout(() => {
        setReRenderCanvas(true);
        setCanvasLoading(false);
      }, 300);
    }, 1500);
    return () => clearTimeout(delay);
  }, [schemaProps]);

  const validateSubmit = () => {
    const dataNotEdited = Object.entries(schemaProps).filter(
      ([key, value]) => requiredFields.includes(key) && value === ""
    );
    if (dataNotEdited.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const clearCreate = () => {
    // removeFile();
    setDoneIssue(false);
    setIssuetoMe(false);
    setIssueVerfied(false);
    setTextJsonCreate();
    setVerified();
    setSchemaProps();
    setSelectedSchema("select");
    setStateJSON("notSubmitted");
  };

  useEffect(() => {
    if (issueVerified) {
      setTimeout(() => {
        const el = document.getElementById("containerBox");
        el.scrollIntoView({
          behavior: "smooth",
        });
      }, 2000);
    }
  }, [issueVerified]);

  useEffect(() => {
    if (issueToMe) {
      // setReRenderCanvas(true);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 1000);
    }
  }, [issueToMe]);

  const Reverify = () => {
    setStatusVC();
    setStatusVP();
    setVerified();
    try {
      let text;

      if (activeBt !== undefined && activeBt !== "") {
        let innetHtmlData = TextAreaRef.current.innerHTML;
        let textReplaceTagselected = innetHtmlData.replace(
          '<span class="selectedJson" id="JsonText">',
          ""
        );
        let textReplaceRemoveId = textReplaceTagselected.replaceAll(
          "</span>",
          ""
        );
        text = textReplaceRemoveId.replace('<span id="removid">', "");
      } else {
        text = TextAreaRef.current.innerHTML;
      }
      isJsonString(text);
      const JsonObj = JSON.parse(text);
      prettyPrint(JSON.stringify(JsonObj), "new");
    } catch (e) {
      console.log(e);
    }
  };
  const createRecordFunc = async (qr) => {
    let schemaData;
    if (qr && stateJSON === "loaded") {
      setIssuetoMe(true);
    } else {
      setLoading(true);
      // console.log("here",selectedDocument);
      if (selectedDocument === "Certificate Schema") {
        schemaData = certificateSchema;
      } else if (selectedDocument === "Job Details Schema") {
        schemaData = jobDetailsSchema;
      } else {
        schemaData = identitySchema;
      }

      let schemaBody = {
        ...schemaData,
        address: `${REACT_APP_PROFILE_ADDRESS}`,
        properties: schemaProps,
      };
      try {
        const response = await fetch(`${REACT_APP_API_URL}/cred`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${REACT_APP_ACCESS_TOKEN}`,
          },
          body: JSON.stringify(schemaBody),
        });

        if (!response.ok) {
          throw new Error("Network response error");
        }
        setLoading(false);
        setLastCreatedJson(schemaProps);
        setStateJSON("loaded");
        if (qr) {
          setIssuetoMe(true);
        }
        let vcOutput = await response.json();
        prettyPrint(JSON.stringify(vcOutput?.vc), "create");
        return;
      } catch (error) {
        console.error("Error creating schema:", error);
        throw error;
      }
    }
  };
  const issueRecordHandler = (event, initiator) => {
    event.preventDefault();
    if (initiator === "Issue") {
      setIssuetoMe(false);
      setStateJSON("notSubmitted");
      // createVc(false);
      createRecordFunc(false);
    } else if (initiator === "Qr") {
      setIssuetoMe(false);
      setDoneIssue(false);
      setIssueVerfied(false);
      setStateJSON("notSubmitted");
      // createVc(true);
      createRecordFunc(true);
    }
  };
  // Add this function near your other handler functions
  const focusJsonContainer = () => {
    if (jsonContainerRef.current) {
      jsonContainerRef.current.scrollIntoView({ behavior: "smooth" });
      // Focus on the editable pre element inside
      const editablePre =
        jsonContainerRef.current.querySelector("pre.text-area");
      if (editablePre) {
        editablePre.focus();
      }
    }
  };

  return (
    <div className="f-screen">
      {actTab === "create" ? (
        <Modalprogress
          loading={loading}
          msg={"Please wait. Anchoring to CORD Blockchain..."}
        />
      ) : null}
      {actTab === "create" ? <Modalsuccess success={successModal} /> : null}
      {actTab === "create" ? <AlreadyExistModal error={errorModal} /> : null}
      <TabsHeading
        list={listtoeknization}
        actTab={actTab}
        setActTab={setActTab}
      />
      {actTab === "create" ? (
        <div className="row m-0 pb-3 border-bottom">
          <div className="col-md-4 mx-auto">
            <div className="mt-3 d-flex justify-content-center">
              Choose the data you want to tokenize
            </div>
            <form>
              <div className="d-flex justify-content-center gap-2 mt-3">
                {schemaList &&
                  schemaList.map((v) => {
                    const schemaID = v.schema.$id;
                    const title = v.registry.details.description;
                    return (
                      <div
                        className={`btn-sub btn-primary px-3 py-2 rounded ${
                          schemaID === selectedSchema ? "" : "opacity-50"
                        }`}
                        key={schemaID}
                        onClick={() => handleChangeSchema(schemaID, title)}
                      >
                        <div
                          id={title}
                          style={{
                            flex: "1 1 0%",
                            width: "150px",
                            height: "130px",
                            objectFit: "fill",
                          }}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <img
                            style={{ maxWidth: "120px", maxHeight: "120px" }}
                            src={
                              title?.toLowerCase().includes("identity")
                                ? identityThumbail
                                : title?.toLowerCase().includes("job")
                                  ? jobDetailsThumbail
                                  : certificateThumbail
                            }
                            alt={`${title} thumbnail`}
                          />
                        </div>
                        <p className="d-flex mb-0 justify-content-center ">
                          {title}
                        </p>
                      </div>
                    );
                  })}
                <div
                  className={`btn-sub btn-primary px-3 py-2 rounded ${
                    fileSchemaSelected ? "" : "opacity-50"
                  }`}
                  key={"file"}
                  onClick={() => handleChangeSchema(80, "fileupload")}
                >
                  <div
                    id={"File"}
                    style={{
                      flex: "1 1 0%",
                      width: "150px",
                      height: "130px",
                      objectFit: "fill",
                    }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <img
                      style={{ maxWidth: "100px", maxHeight: "120px" }}
                      src={fileThumb}
                      alt={`${File} thumbnail`}
                    />
                  </div>
                  <p className="d-flex mb-0 justify-content-center ">File</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      ) : null}

      <div id="inputSchema">
        {schemaProps && actTab === "create" ? (
          <div className="d-flex m-0">
            <div className=" mt-5 w-50 mx-auto">
              {selectedDocument === "Certificate Schema" ? (
                <CertificateSchemaInput
                  handleDatePicker={handleDataPicker}
                  schemaProps={schemaProps}
                  handleChangeFields={handleChangeFields}
                  handlePic={handlePic}
                  requiredFields={requiredFields}
                  setSchemaProps={setSchemaProps}
                  loading={loading}
                />
              ) : selectedDocument === "Job Details Schema" ? (
                <JobDetailsSchemaInput
                  handleDatePicker={handleDataPicker}
                  schemaProps={schemaProps}
                  handleChangeFields={handleChangeFields}
                  requiredFields={requiredFields}
                />
              ) : (
                <IdentitySchemaInput
                  handleDatePicker={handleDataPicker}
                  schemaProps={schemaProps}
                  handleChangeFields={handleChangeFields}
                  handlePic={handlePic}
                  requiredFields={requiredFields}
                  setSchemaProps={setSchemaProps}
                  loading={loading}
                />
              )}
            </div>

            <div
              id={"certificate-preview"}
              style={{ flex: "1 1 0%" }}
              className="overflow-x-hidden overflow-y-auto w-50 p-5"
            >
              {canvasLoading ? (
                <div className="d-flex justify-content-center">
                  <Loaderflip />
                </div>
              ) : (
                <LoadCanvasPages
                  pageCanvas={pageCanvas}
                  thumbnails={thumbnails}
                  divId={"certificate-preview"}
                  generateThumbnail={true}
                  setRenderCanvas={setReRenderCanvas}
                  renderCanvas={reRenderCanvas}
                  pagesArray={Object.values(ModifiedConfig.current)}
                  // setThumbnailsUrl={setThumbnailUrl}
                />
              )}
            </div>
          </div>
        ) : null}
      </div>
      {schemaProps && actTab === "create" && (
        <>
          <div className="d-flex justify-content-center pt-3 pb-5">
            {/* <button
                  type="submit"
                  className="btn btn-primary  btn-sub mx-3"
                  onClick={() => setReRenderCanvas(true)}
                >
                  Update
                </button> */}
            <button
              type="submit"
              className="btn btn-primary  btn-sub"
              onClick={(e) => issueRecordHandler(e, "Issue")}
              disabled={
                validateSubmit() ||
                loading ||
                JSON.stringify(schemaProps) === JSON.stringify(lastCretedJson)
              }
            >
              Issue
            </button>
            <button
              type="submit"
              className={
                actTab === "create" ? "btn btn-primary  mx-3 btn-sub" : "nodis"
              }
              onClick={(e) => issueRecordHandler(e, "Qr")}
              disabled={validateSubmit() || loading}
            >
              Issue to Wallet
            </button>
            <button
              type="submit"
              className={
                actTab === "create" ? "btn btn-primary  btn-sub " : "nodis"
              }
              onClick={clearCreate}
              disabled={stateJSON !== "loaded"}
            >
              Clear
            </button>
          </div>
        </>
      )}

      <div className="qrcontainer">
        {actTab === "create" && issueToMe ? (
          <QRCard
            selectedDocument={selectedDocument}
            vc={textJsonCreate ?? textJsonCreate}
            schemaProps={schemaProps}
            selectedRegistryData={selectedRegistryData}
            clearCreate={clearCreate}
            setIssueVerfied={setIssueVerfied}
            doneIssue={doneIssue}
            setDoneIssue={setDoneIssue}
            setAlreadyExist={setAlreadyExist}
            selectedSchemaData={selectedSchemaData}
          />
        ) : null}
      </div>
      <div
        className={stateJSON === "loaded" || actTab === "verify" ? "" : "nodis"}
      >
        <div
          className={
            actTab === "verify" || (issueToMe && !issueVerified)
              ? "nodis"
              : actTab == "update" || actTab == "revoke"
                ? "d-none"
                : ""
          }
          id="containerBox"
        >
          <div className="bottom-contents pt-5 pb-5">
            <div className="outer-area">
              <div className="col-md-12 d-flex">
                <div className="col-md-12 position-relative">
                  <p className="outer-text pe-none">
                    {actTab === "verify" ? (
                      <span>Copy paste or Drag & drop JSON </span>
                    ) : (
                      <span>JSON </span>
                    )}
                  </p>
                </div>
              </div>
              <div className="inner-area">
                <div className="drag-area-width ">
                  {textJsonCreate && (
                    <div
                      className="copy-action cursor-pointer"
                      onClick={() => copyToClipBoard(textJsonCreate)}
                      id="copyId"
                    >
                      <img src="copy-icon.svg" alt="delete" />
                      <span className="tipCopy">
                        {copied ? "Copied" : "Copy"}
                      </span>
                    </div>
                  )}
                  <pre
                    contentEditable={false}
                    className="text-area"
                    suppressContentEditableWarning={true}
                  >
                    <span>{textJsonCreate}</span>
                  </pre>
                </div>
              </div>
            </div>
            <div className="text-center"></div>
          </div>
        </div>
      </div>

      {fileSchemaSelected && actTab === "create" ? (
        <div className="row mt-5 mx-0">
          <div className="col-md-4 justify-content-center mx-auto d-flex  ">
            <Fileinput actTab={actTab} />
          </div>
          <p className="text-center mt-3 fw-bolder">
            Upload your file to securely anchor its unique digital fingerprint
            on the blockchain.
          </p>
        </div>
      ) : null}

      {actTab === "update" ? <UpdatedocInput /> : null}

      {actTab === "revoke" ? (
        <div className="row mt-5 mx-0">
          <div className="col-md-8 justify-content-center mx-auto ">
            <RevokeInput />
            <p className="text-left mt-2 subtxt">
              Note: To revoke an existing file, enter the identifier. This will
              securely revoke its digital fingerprint on the blockchain
            </p>
          </div>

          <div className="hr-with-text">OR</div>
          <div className="col-md-4 justify-content-center mx-auto d-flex mt-2  ">
            <Fileinput actTab={actTab} />
          </div>
          <p className="text-center mt-3 fw-bolder">
            Upload your file to revoke its unique digital fingerprint securely
            on the blockchain.
          </p>
        </div>
      ) : null}

      {/* Verify Clipboard */}

      <div className={actTab === "verify" ? "" : "nodis"}>
        <QRCardVerify actTab={actTab} prettyPrint={prettyPrint} />
        <div className="hr-with-text">OR</div>
        <div className="row m-0">
          <div className="col-md-6 mt-3 mx-auto d-flex justify-content-center align-items-center">
            <Fileinput actTab={actTab} />
          </div>
          <p className="text-center mt-3 fw-bolder">
            Upload a file to verify its authenticity and check if it has been
            anchored on the blockchain.
          </p>
          <div className="hr-with-text">OR</div>
        </div>
        <div className="ReverifyBt col-md-12 d-flex justify-content-center align-items-center mt-2">
          <button
            className={reverify ? "btn btn-primary btn-sub" : "nodis"}
            onClick={Reverify}
          >
            Reverify
          </button>
        </div>
        <div className="bottom-contents pt-3 pb-5 mb-5">
          <div className="outer-area">
            <div className="col-md-12 d-flex">
              <div className="col-md-12 position-relative">
                <p
                  className="outer-text"
                  onClick={focusJsonContainer}
                  style={{ cursor: "pointer" }}
                >
                  {actTab === "verify" ? (
                    <span>Copy paste or Drag & drop JSON </span>
                  ) : (
                    <span>JSON </span>
                  )}
                </p>

                <div className="action-buttons d-flex">
                  <input
                    className="fileUpload"
                    type="file"
                    id="file"
                    ref={inputJson}
                    style={{ display: "none" }}
                    accept="application/JSON, text/plain"
                  />

                  <div
                    className="cursor-pointer me-2 folderLoad"
                    style={{ display: "none" }}
                  >
                    <img
                      htmlFor="file"
                      src="openFolder.svg"
                      alt="Loader"
                      onClick={() => {
                        inputJson.current.click();
                      }}
                      id="openFolder"
                    ></img>
                    <span className="tipfolderLoad">Load File</span>
                  </div>
                  {textJson && (
                    <div
                      className=" cursor-pointer clearCls"
                      onClick={() => removeFile()}
                    >
                      <img src="delete.svg" alt="delete" />
                      <span className="tipClear">Clear</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="inner-area">
              <div
                className={
                  actTab === "create"
                    ? "drag-area-width drag-area"
                    : "drag-area"
                }
                ref={jsonContainerRef}
                onClick={focusJsonContainer}
                tabIndex={-1}
              >
                {textJson && (
                  <div
                    className="copy-action cursor-pointer"
                    onClick={() => copyToClipBoard(textJson)}
                    id="copyId"
                  >
                    <img src="copy-icon.svg" alt="delete" />
                    <span className="tipCopy">
                      {copied ? "Copied" : "Copy"}
                    </span>
                  </div>
                )}
                {loadingTxt ? (
                  <Loaderspinner />
                ) : (
                  <pre
                    contentEditable={true}
                    className="text-area"
                    suppressContentEditableWarning={true}
                    onClick={() => {
                      if (!textJson) {
                        setTextJson("");
                      }
                    }}
                  >
                    {textJson || textJson === "" ? (
                      <span ref={TextAreaRef}> {textJson} </span>
                    ) : (
                      <span className="txtBlinker">|</span>
                    )}
                  </pre>
                )}
                {/* <textarea id="text-area" className='w-100 h-100'  value={textJson} /> */}
                {/* <pre className='drop-header'>
                  <p className='drag-status'></p>
                </pre> */}
              </div>
              <div
                className={
                  actTab !== "create"
                    ? textJson
                      ? "verify-area enable-border"
                      : "verify-area"
                    : "verify-area enable-border nodis"
                }
              >
                <div id="verification">
                  {/* {isProgress && actTab !== "create" ? (
                    <div className="col-md-12 verify-header">
                      <Loaderspinner />
                    </div>
                  ) : (
                    <> */}
                  {/* {statusVc && textJson && ( */}
                  {actTab === "verify" && textJson && verified === "VC" ? (
                    <VCstatus
                      statusVc={statusVc}
                      isProgress={isProgress}
                      activeBt={activeBt}
                      scrollIntoCordProof2025={scrollIntoCordProof2025}
                      scrollIntoCordSDRProof={scrollIntoCordSDRProof}
                      scrollIntoSignature={scrollIntoSignature}
                    />
                  ) : actTab === "verify" && textJson && verified === "VP" ? (
                    <VPstatus
                      textJson={textJson}
                      isProgress={isProgress}
                      statusVp={statusVp}
                      activeBt={activeBt}
                      scrollIntoCordProofVP={scrollIntoCordProofVP}
                      scrollIntoCordSDRProofVP={scrollIntoCordSDRProofVP}
                      scrollIntoSignatureVP={scrollIntoSignatureVP}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="snackbar">Copied to clipboard</div>
      </div>

      {!footerClose ? <Footer setFooterClose={setFooterClose} /> : null}
    </div>
  );
}

export default Verify;
